
document.addEventListener("DOMContentLoaded", function () {

    interceptCheckout();

});


function interceptCheckout() {

    document.addEventListener(
        "click",
        function(event) {


            const checkoutButton = event.target.closest(
                'button[name="checkout"], #checkout'
            );


            if (!checkoutButton) {
                return;
            }


            // STOP CHECKOUT IMMEDIATELY
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();


            fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {


                const hasSubscription = cart.items.some(
                    item => item.selling_plan_allocation
                );


                if(hasSubscription){

                    openLicenseModal();

                } else {

                    // allow normal checkout
                    // checkoutButton.closest("form")?.submit();

                    const form = checkoutButton.form || checkoutButton.closest("form");
                    if (form) {
                        form.requestSubmit(checkoutButton);
                    } else {
                        window.location.href = "/checkout";
                    }

                }


            });


        },
        true
    );

}





function openLicenseModal(){

const modal =
document.querySelector(
"#licenseAgreementModal"
);


if(modal){

document.querySelector(".cart-drawer__close-button")?.click();

modal.hidden=false;

document.body.style.overflow="hidden";

}

}





function closeLicenseModal(){

const modal =
document.querySelector(
"#licenseAgreementModal"
);


if(modal){

modal.hidden=true;

document.body.style.overflow="";

}

}





async function saveLicenseAcceptance(){


const checkbox =
document.querySelector(
"#licenseAgreementCheckbox"
);



if(!checkbox.checked){

alert(
"Please accept the License Agreement before continuing."
);

return;

}



await fetch(
"/cart/update.js",
{

method:"POST",

headers:{
"Content-Type":"application/json"
},

body:JSON.stringify({

attributes:{

"License Agreement":
"Accepted",

"License Agreement Version":
"July 27, 2026",

"License Accepted Date":
new Date().toISOString()

}

})

});



window.location.href="/checkout";

// document.querySelector("#checkout").click();

}





document.addEventListener(
"click",
function(event){



if(
event.target.id ===
"licenseAgreementContinue"
){

event.preventDefault();

saveLicenseAcceptance();

}




if(
event.target.id ===
"licenseModalClose"
||
event.target.classList.contains(
"license-modal__overlay"
)
){

closeLicenseModal();

}



});







async function checkExpressCheckout(){

    const cart =
    await fetch('/cart.js')
    .then(response => response.json());


    const hasSubscription =
    cart.items.some(item =>
        item.selling_plan_allocation
    );


    const expressButtons =
    document.querySelector(
        ".additional-checkout-buttons"
    );


    if(expressButtons){

        expressButtons.style.display =
        hasSubscription ? "none" : "";

    }

}




// Initial load
document.addEventListener(
"DOMContentLoaded",
checkExpressCheckout
);


// Horizon cart events
document.addEventListener(
"cart:updated",
checkExpressCheckout
);


// Backup observer because Horizon replaces HTML
const observer =
new MutationObserver(() => {

    checkExpressCheckout();

});


observer.observe(
document.body,
{
childList:true,
subtree:true
});